// extracted by mini-css-extract-plugin
module.exports = {"SocialIcon":"SocialIcon_SocialIcon__20sB6","Link":"SocialIcon_Link__3BR3H"};